require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var createNumberArray_1 = require("../utilities/createNumberArray");

var computeAbsoluteOrigin_1 = require("./computeAbsoluteOrigin");

function fillSegments(larger, smaller, origin) {
  var largeLen = larger.length;
  var smallLen = smaller.length;

  if (largeLen < smallLen) {
    return fillSegments(smaller, larger, origin);
  }

  smaller.length = largeLen;

  for (var i = smallLen; i < largeLen; i++) {
    var l = larger[i];
    var originX = origin.x;
    var originY = origin.y;

    if (!origin.absolute) {
      var absoluteOrigin = computeAbsoluteOrigin_1.computeAbsoluteOrigin(originX, originY, l);
      originX = absoluteOrigin.x;
      originY = absoluteOrigin.y;
    }

    var d = createNumberArray_1.createNumberArray(l.length);

    for (var k = 0; k < l.length; k += 2) {
      d[k] = originX;
      d[k + 1] = originY;
    }

    smaller[i] = d;
  }
}

exports.fillSegments = fillSegments;